import { render, staticRenderFns } from "./consultRecords.vue?vue&type=template&id=431909b0&scoped=true&"
import script from "./consultRecords.vue?vue&type=script&lang=js&"
export * from "./consultRecords.vue?vue&type=script&lang=js&"
import style0 from "./consultRecords.vue?vue&type=style&index=0&id=431909b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "431909b0",
  null
  
)

export default component.exports